import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import {AccountService} from "../../../../services/account.service";
import {FormControl} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-equity-summary',
  templateUrl: './equity-summary.component.html',
  styleUrls: ['./equity-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class EquitySummaryComponent implements OnInit {
  balanceInProgress = false;
  accountFinBalances = null;
  currentUser;
  paramInvestorCode = null;
  portfolioUrl = '';
  transactionsUrl = '';
  downloadReports = '';
  calsBalancesDetails = [];
  fundId = new FormControl({ customerCode: '', customerName: '' }, []);
  constructor(private cdRef: ChangeDetectorRef,
              private accountService: AccountService,
              private activatedRoute: ActivatedRoute,
              private route: Router) { }

  async ngOnInit() {
    this.balanceInProgress = true;
    this.cdRef.detectChanges();
    this.currentUser = await this.accountService.currentUserAsync();
    await this.getCalsBalances();
    this.currentUser.investorCodeDetails.forEach((jontAcc, index) => (jontAcc['index'] = index));

    this.activatedRoute.params.subscribe((params) => {
      this.paramInvestorCode = params['investorCode'];
      this.transactionsUrl = '/dashboard/equity/summary/' + params['investorCode'] + '/transactions';
      this.portfolioUrl = '/dashboard/equity/summary/' + params['investorCode'] + '/portfolio';
      this.downloadReports = '/dashboard/equity/summary/' + params['investorCode'] + '/download-statements'
      this.fundId.setValue({ customerCode: params['investorCode'],customerName: '' });
      this.cdRef.detectChanges();
    });
  }

  async check(data) {
    this.transactionsUrl = '/dashboard/equity/summary/' + data.customerCode + '/transactions';
    this.portfolioUrl = '/dashboard/equity/summary/' + data.customerCode + '/portfolio';
    this.downloadReports = '/dashboard/equity/summary/' + data.customerCode + '/download-statements'
    await this.route.navigate([`/dashboard/equity/summary/${data.customerCode}/portfolio`]);
  }

  async getCalsBalances() {
    try {
      this.balanceInProgress = true;
      this.cdRef.detectChanges();
      for(let acc = 0 ; acc < this.currentUser.investorCodeDetails.length; acc++) {
        let s = await this.accountService.getAccountFinBalances(this.currentUser.investorCodeDetails[acc].customerCode);
        s[0].index = acc;
        s[0].customerCode = s[0].investorCode;
        s[0].customerName = s[0].investorName;
        this.calsBalancesDetails.push(s[0]);
      }
      console.log(this.calsBalancesDetails)
      this.balanceInProgress = false;
      this.cdRef.detectChanges();
    } catch (e) {
      this.balanceInProgress = false;
      this.cdRef.detectChanges();
    }
  }

  async getAccountFinBalances(profileId?) {
    try {
      this.balanceInProgress = true;
      let accountFinBalances = await this.accountService.getAccountFinBalances(profileId);
      this.accountFinBalances = accountFinBalances[0];
      this.balanceInProgress = false;
      this.cdRef.detectChanges();
    } catch (e) {
      this.balanceInProgress = false;
      this.cdRef.detectChanges();
    }
  }

}
